export class Config {
  public static HISTORY_ON_ONE_PAGE = 25;
  public static DEFAULT_PAGE_NO = 1;

  public static GDO_STATUS = {
    CLOSED: {
      code: '01',
      image: '../../../assets/images/gdo/Closed.svg',
      art: 'Closed',
      'en-us': 'Closed',
      fr: 'Fermé'
    },
    OPEN: {
      code: '03',
      image: '../../../assets/images/gdo/Open.svg',
      art: 'Open',
      'en-us': 'Open',
      fr: 'Ouvert'
    },
    CLOSING: {
      code: '07',
      image: '../../../assets/images/gdo/Open.svg',
      art: 'Closing',
      'en-us': 'Closing',
      fr: 'Fermeture'
    },
    OPENING: {
      code: '08',
      image: '../../../assets/images/gdo/Closed.svg',
      art: 'Opening',
      'en-us': 'Opening',
      fr: 'Ouverture'
    },
    PARTIAL: {
      code: '09',
      image20: '../../../assets/images/gdo/Open20.svg',
      image40: '../../../assets/images/gdo/Open40.svg',
      image60: '../../../assets/images/gdo/Open60.svg',
      image80: '../../../assets/images/gdo/Open80.svg',
      art: 'Open',
      'en-us': 'Open',
      fr: 'Ouvert à'
    },
    INTERIM_POS: {
      code: '05',
      image20: '../../../assets/images/gdo/Open20.svg',
      image40: '../../../assets/images/gdo/Open40.svg',
      image60: '../../../assets/images/gdo/Open60.svg',
      image80: '../../../assets/images/gdo/Open80.svg',
      art: 'Interim Position',
      'en-us': 'Interim Position',
      fr: 'Position Intermédiaire'
    },
    NO_CONNECTION: {
      code: '02',
      image: '../../../assets/images/gdo/GDOAlert.svg',
      art: 'No Connection',
      'en-us': 'No Connection',
      fr: 'Pas de connexion'
    },
    UNKNOWN_STATUS: {
      code: '02',
      image: '../../../assets/images/gdo/GDOAlert.svg',
      art: 'No Connection',
      'en-us': 'No Connection',
      fr: 'Pas de connexion'
    },
  };

  public static BATTERY = {
    AC: {
      'en-us': 'AC',
      fr: 'AC'
    },
    FLAT: {
      'en-us': 'Critically Low',
      fr: 'Très bas'
    },
    LOW: {
      'en-us': 'Low',
      fr: 'Bas'
    },
    MEDIUM: {
      'en-us': 'Medium',
      fr: 'Moyen'
    },
    FULL: {
      'en-us': 'Full',
      fr: 'Plein'
    }
  };

  public static ERROR_MESSAGE = {
    CLOSE_FAILED: {
      'en-us': 'Door Close Failed. Ensure there are no objects blocking the photo beam or the garage door travel path.',
      fr: 'Échec de la fermeture de la porte. Assurez-vous qu\'aucun objet ne bloque le faisceau photoélectrique ou la trajectoire de la porte du garage.'
    },
    OPEN_FAILED: {
      'en-us': 'Door Open Failed. Ensure there are no objects blocking the garage door travel path.',
      fr: 'Échec de l\'ouverture de la porte. Assurez-vous qu\'aucun objet ne bloque la trajectoire de la porte du garage.'
    },
    DISABLED_SENSOR_MISALIGNED: {
      'en-us': 'Sensors are misaligned. Check to see if photo beam is mis-aligned.',
      fr: 'Les capteurs sont mal alignés. Alignez les faisceaux photoélectriques.'
    },
    OBSTRUCTION_CLOSE_FAILED: {
      'en-us': 'Door Close Failed. Ensure there are no objects blocking the garage door travel path.',
      fr: 'Échec de la fermeture de la porte. Assurez-vous qu\'aucun objet ne bloque la trajectoire de la porte du garage.'
    },
    OBSTRUCTION_OPEN_FAILED: {
      'en-us': 'Door Open Failed. Ensure there are no objects blocking the garage door travel path.',
      fr: 'Échec de l\'ouverture de la porte. Assurez-vous qu\'aucun objet ne bloque la trajectoire de la porte du garage.'
    },
    MISALIGNED_CLOSE_FAILED: {
      'en-us': 'Door Close Failed. Ensure there are no objects blocking the photo beam.',
      fr: 'Échec de la fermeture de la porte. Assurez-vous qu\'aucun objet ne bloque le faisceau photoélectrique.'
    },
    NO_CONNECTION: {
      'en-us': 'Opener is not connected. Please check your Wi-Fi network.',
      fr: 'L\'ouvre-porte n\'est pas connecté. Veuillez vérifier votre réseau Wi-Fi.'
    },
    VACATION_MODE: {
      'en-us': 'The Opener is in Vacation Lock.',
      fr: 'L\'ouvre-porte est en mode verrouillage vacances.'
    },
    VACATION_MODE_PENDING: {
      'en-us': 'The Opener is in Vacation Lock Pending.',
      fr: 'L\'ouvre-porte est en attente de verrouillage vacances.'
    },
    REQUIRED_FIRMWARE_UPDATE: {
      'en-us': 'A firmware update is required.',
      fr: 'Il est nécessaire d\'effectuer une mise à jour du micrologiciel.'
    },
    MULTIPLE_REQUIRED_FIRMWARE_UPDATE: {
      'en-us': 'Multiple firmware updates are required.',
      fr: 'Il est nécessaire de procéder à plusieurs mises à jour du micrologiciel.'
    },
    AVAILABLE_FIRMWARE_UPDATE: {
      'en-us': 'A Firmware update is available.',
      fr: 'Une mise à jour du micrologiciel est disponible.'
    },
    MULITPLE_AVAILABLE_FIRMWARE_UPDATE: {
      'en-us': 'Multiple firmware updates are available.',
      fr: 'Plusieurs mises à jour du micrologiciel sont disponibles.'
    },
    FLAT_BATTERY: {
      'en-us': 'Make sure the Opener is properly connected to the AC Power.',
      fr: 'Assurez-vous que l’ouvre-porte est correctement connecté à l\'alimentation CA'
    },
    LOW_BATTERY: {
      'en-us': 'Make sure the Opener is properly connected to the AC Power.',
      fr: 'Assurez-vous que l’ouvre-porte est correctement connecté à l\'alimentation CA'
    },
    NO_RECORDS_FILTER: {
      'en-us': 'No events available for this device according to the applied filters.',
      fr: 'Aucun événement n\'est disponible pour cet appareil selon les filtres appliqués.'
    },
    NO_RECORDS: {
      'en-us': 'No events available for this device.',
      fr: 'Aucun événement n\'est disponible pour cet appareil.'
    },

  };

  public static UPDATE_STATUS_SECONDS = 300;


  public static EVENT = {
    EVENT_BY: {
      MATTER:{
        'en-us': 'Matter',
        fr: 'Matter'
      },
      WS: {
        'en-us': 'Wall Station',
        fr: 'La station murale'
      },
      APP: {
        'en-us': 'APP',
        fr: 'APP'
      },
      REMOTE: {
        'en-us': 'Remote Control/Keypad',
        fr: 'Télécommande/clavier'
      },
      WI_FI: {
        'en-us': 'Wi-Fi Network',
        fr: 'Réseau Wi-Fi'
      },
      OBSTRUCTION_FAILURE: {
        'en-us': 'Obstruction Failure',
        fr: 'Échec de l\'obstruction'
      },
      SENSOR_OBSTRUCTION: {
        'en-us': 'Sensor Obstruction',
        fr: 'Obstruction des capteurs'
      },
      AUTO_CLOSE_SCHEDULE: {
        'en-us': 'Auto Close by Schedule',
        fr: 'Fermeture automatique en fonction de l\'horaire'
      },
      AUTO_CLOSE_DELAY: {
        'en-us': 'Auto Close by Delay',
        fr: 'Fermeture automatique en fonction du délai'
      },
      ALEXA: {
        'en-us': 'Alexa',
        fr: 'Alexa'
      },
      GOOGLE: {
        'en-us': 'Google Home',
        fr: 'Google Home'
      },
      SMART_THINGS: {
        'en-us': 'SmartThings',
        fr: 'SmartThings'
      }
    },
    EVENT_NAME: {
      OPEN: {
        'en-us': 'Open',
        fr: 'Ouvert'
      },
      CLOSE: {
        'en-us': 'Closed',
        fr: 'Fermé'
      },
      OBSTRUCTION_AT : {
        'en-us': 'Obstruction Occurred at',
        fr: 'Obstruction survenue à'
      },
      OBSTRUCTION : {
        'en-us': 'Obstruction Occurred',
        fr: 'Une obstruction est survenue'
      },
      OBSTRUCTION_FAILURE: {
        'en-us': 'Obstruction Failure',
        fr: 'Échec de l\'obstruction'
      },
      SENSOR_OBSTRUCTION: {
        'en-us': 'Sensor Obstruction',
        fr: 'Obstruction du capteur '
      },
      VACATION_ON: {
        'en-us': 'Vacation Lock Activated',
        fr: 'Verrouillage vacances activé'
      },
      VACATION_OFF: {
        'en-us': 'Vacation Lock Off',
        fr: 'Verrouillage vacances désactivé'
      },
      DISABLED: {
        'en-us': 'Disabled',
        fr: 'Désactivé'
      },
      BATTERY_FLAT: {
        'en-us': 'Battery Critically Low',
        fr: 'Batterie très bas'
      },
      BATTERY_LOW: {
        'en-us': 'Battery is Low',
        fr: 'La batterie est bas'
      },
      AC_POWER: {
        'en-us': 'Opener is using AC Power',
        fr: 'L\'ouvre-porte fonctionne sur courant alternatif'
      },
      ON_BATTERY: {
        'en-us': 'Opener is using Battery',
        fr: 'L\'ouvre-porte fonctionne sur batterie'
      },
      WI_FI_CONNECTED: {
        'en-us': 'Wi-Fi network is connected',
        fr: 'Le réseau Wi-Fi est connecté'
      },
      WI_FI_DISCONNECTED: {
        'en-us': 'Wi-Fi network is disconnected',
        fr: 'Le réseau Wi-Fi est déconnecté'
      },
      DEVICE_ACTIVATION: {
        'en-us': 'Device Activation',
        fr: 'Activation de l\'appareil'
      },
      UNKNOWN: {
        'en-us': 'Unknown',
        fr: 'Inconnu'
      },
      OPENER: {
        'en-us': 'Opener',
        fr: 'L\'ouvre-porte'
      }
    },
    COLOR: {
      Orange: 'list-row-data row-data-orange',
      Green: 'list-row-data row-data-green',
      Red: 'list-row-data row-data-red',
      Blue: 'list-row-data row-data-blue',
      Gray: 'list-row-data row-data-gray',
    },
    HOME_COLOR: {
      Orange: 'list-row-data row-data-orange',
      Green: 'list-row-data row-data-green',
      Red: 'list-row-data row-data-red',
      Blue: 'list-row-data row-data-blue',
      Gray: 'list-row-data row-data-gray',
    }

  }

  public static HISTORY_CHECKLISTS = [
    {
      'en-us': 'Open',
      fr: 'Ouvert',
      event: [
        {
          groupId: '1',
          eventId: '3'
        }
      ]
    },
    {
      'en-us': 'Closed',
      fr: 'Fermé',
      event: [
        {
          groupId: '1',
          eventId: '1'
        }
      ]
    },
    {
      'en-us': 'XX% Open',
      fr: 'Ouvert à XX%',
      event: [
        {
          groupId: '1',
          eventId: '5'
        },
        {
          groupId: '1',
          eventId: '9'
        }
      ]
    },
    {
      'en-us': 'Obstruction',
      fr: 'Obstruction',
      event: [
        {
          groupId: '8'
        },
        {
          eventBy: '13',
        },
        {
          eventBy: '14',
        }
      ]
    },
    {
      'en-us': 'Disabled',
      fr: 'Désactivé',
      event: [
        {
          groupId: '9'
        }
      ]
    },
    {
      'en-us': 'Device Activation',
      fr: 'Activation de l\'appareil',
      event: [
        {
          groupId: '7'
        }
      ]
    },
    {
      'en-us': 'Vacation Lock Off',
      fr: 'Verrouillage vacances désactivé',
      event: [
        {
          groupId: '4',
          eventId: '0'
        }
      ]
    },
    {
      'en-us': 'Vacation Lock Activated',
      fr: 'Verrouillage vacances activé',
      event: [
        {
          groupId: '4',
          eventId: '1'
        }
      ]
    },
    {
      'en-us': 'Battery is Critically Low',
      fr: 'La batterie est très bas',
      event: [
        {
          groupId: '5',
          eventId: '0'
        }
      ]
    },
    {
      'en-us': 'Battery is Low',
      fr: 'La batterie est bas',
      event: [
        {
          groupId: '5',
          eventId: '1'
        }
      ]
    },
    {
      'en-us': 'Opener is using Battery',
      fr: 'L\'ouvre-porte fonctionne sur batterie',
      event: [
        {
          groupId: '5'
        }
      ]
    },
    {
      'en-us': 'Opener is back on AC Power',
      fr: 'L\'ouvre-porte est de nouveau alimenté en courant alternatif',
      event: [
        {
          groupId: '5',
          eventId: '5'
        }
      ]
    },
    {
      'en-us': 'Wi-Fi Network: Disconnected',
      fr: 'Réseau Wi-Fi : déconnecté',
      event: [
        {
          groupId: '3',
          eventId: '0'
        }
      ]
    },
    {
      'en-us': 'Wi-Fi Network: Connected',
      fr: 'Réseau Wi-Fi : connecté',
      event: [
        {
          groupId: '3',
          eventId: '1'
        }
      ]
    }
  ];

}
